import React from "react";

import { getIubendaPolicyId, getLanguageFromLocalStorage } from "utils";

import { LANGUAGE_CODE } from "consts";

export const POLICY_TYPE = {
  COOKIE: "COOKIE",
  PRIVACY: "PRIVACY",
} as const;

type PolicyType = (typeof POLICY_TYPE)[keyof typeof POLICY_TYPE];

const PolicyPage = ({ policyType }: { policyType: PolicyType }) => {
  const language = getLanguageFromLocalStorage();

  const getLink = ({ language }: { language: LANGUAGE_CODE }) => {
    const policyId = getIubendaPolicyId(language);

    if (policyType === POLICY_TYPE.COOKIE) {
      return `https://www.iubenda.com/privacy-policy/${policyId}/cookie-policy`;
    }
    return `https://www.iubenda.com/privacy-policy/${policyId}`;
  };

  const link = getLink({ language });

  return <iframe style={{ width: "100%", height: "100vh", border: "0" }} src={link} />;
};
export default PolicyPage;
